import helpers from './helpers';

const PROD_AU_SHOP_DOMAIN = 'gncvxw-wt.myshopify.com';
const DEV_AU_SHOP_DOMAIN = 'db-aus-dev.myshopify.com';

const publicAccessToken = {
  [PROD_AU_SHOP_DOMAIN]: '',
  [DEV_AU_SHOP_DOMAIN]: ''
};

const storefrontAccessToken = {
  [PROD_AU_SHOP_DOMAIN]: 'e3ed9c556e64480c74c0c8d56bffe1af',
  [DEV_AU_SHOP_DOMAIN]: '5da099484a646f0aaca1562aed6593a4'
};

export default {
  getPublicAccessToken() {
    return publicAccessToken[helpers.getShopDomain()];
  },

  getStorefrontToken() {
    return storefrontAccessToken[helpers.getShopDomain()];
  },

  getXhrRequestConfig() {
    // XHR request header is required to catch certain errors e.g. adding over quantity available
    // https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
    // https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
    return {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
  },

  getAdminGraphqlBaseUrl() {
    return `${helpers.getDomain()}/admin/api/2025-07/graphql.json`;
  },

  getStorefrontGraphqlBaseUrl() {
    return `/api/2025-07/graphql.json`;
  }
};
